import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { darken } from 'polished';
import React, { ComponentProps } from 'react';
import { compose, variant } from 'styled-system';

import { Button as BlocksButton } from '~/components/blocks';

const Root = styled(BlocksButton)<Props>(
  ({ theme }) =>
    css({
      color: theme.colors.text.white,
      background: theme.colors.background.patientPrimary,
      border: theme.borders.transparent,
      '&:disabled': {
        backgroundColor: theme.colors.background.patientPrimary,
        borderColor: 'transparent',
      },
      '&:active': {
        background: darken(0.05, theme.colors.background.patientPrimary),
      },
    }),
  ({ theme }) =>
    compose(
      variant({
        prop: 'use',
        variants: {
          white: css({
            color: theme.colors.text.default,
            background: theme.colors.background.default,
            border: theme.borders.patientNavy,
            '&:hover': {
              boxShadow: 'none',
              background: theme.colors.background.bg,
            },
            '&:active': {
              boxShadow: 'none',
            },
          }),
        },
      }),
    ),
);

type Props = ComponentProps<typeof BlocksButton>;

export const Button = (props: Props) => {
  return <Root {...props} />;
};
